export const getRightLabel = (type) => {
    switch (type) {
        case 'clip':
            return 'CLIP';
        case 'autohighlight':
            return 'AUTO HIGHLIGHTS';
        case 'hd':
        case 'pano':
            return 'FULL GAME';
        case 'highlight':
        case 'player-highlight':
            return 'PLAYER HIGHLIGHTS';
    }
};

export const getLeftLabel = (type, attributes, name) => {
    let label = '';
    switch (type) {
        case 'clip':
        case 'autohighlight':
        case 'hd':
        case 'pano':
            label = name || '';
            break;
        case 'highlight':
        case 'player-highlight':
            label = `# ${attributes.team.player}`;
            break;
    }

    return label.toUpperCase();
};
